import React from 'react'
import { Widget } from '@typeform/embed-react'
import { PageType } from '../../interfaces/types';

const SurveyPage = (props: {
  setCurrentPage: (page: PageType) => void;
  onSubmitHook: () => void;
}) => {

  const handleSubmit = (payload: {
      responseId: string
  }) => {
      props.onSubmitHook();
      props.setCurrentPage('RESULT');
  }

  return (
    <div>
      <Widget id='rYGBV07D' style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          borderRadius: 'none',
          display: 'block',
          wordBreak: 'keep-all',
      }}
      onSubmit={handleSubmit}
      ></Widget>
      <h1
        style={{
        }}
      >Loading...</h1>
    </div>
  )
}

export default SurveyPage